module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAArklEQVRIS2NkoDFgpLH5DLS3IG2xvOR/hv/PQD6ZHfuIMWWxXBojA8NM4nz2f9rs2MfZ+NSCfZCyUK6BgYnh2ZzYR7PgfGJsYGHYPCf60VmCFhBjFrlqaB8H5LqMWH2jPiAYUuAgSl0su5+RgfHzrNhHfilL5YwZ//3vIaiTCAWzYx870scCIhxDtpLRVEQw6IZJEBFVXDMx/McIDyaGLQSLa7pUOARjigIFQz+SARkNQxkcH34oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.png
// module id = +TIe
// module chunks = 1